{
  "pipeData": {
    "bm.customer.billing.account.dunning.payment.plan": {
      "data": [{
        "id": 10001,
        "customerBillingAccount": {
          "id": 20001,
          "currency": "EUR",
          "paymentMethod": "SEPA",
          "closed": false,
          "name": "Main Billing Account",
          "balances": [
            {
              "id": 30001,
              "balance": -228.49,
              "activeBalance": -228.49,
              "currency": "EUR",
              "lastActiveBalancedDebitTransaction": {
                "id": 40001,
                "transactionDirection": "DEBIT",
                "status": "FAILED",
                "valutaDate": "2024-12-01",
                "amount": -38.08,
                "currency": "EUR",
                "creditPaymentMethod": "SEPA",
                "version": 1
              }
            }
          ],
          "contractPaymentAccounts": [
            {
              "id": 50001,
              "startDate": "2022-01-01",
              "endDate": null,
              "frequency": "MONTHLY",
              "firstPaymentDate": "2022-01-01",
              "nextPaymentDate": "2025-01-01",
              "contract": {
                "id": 60001,
                "entityStatus": "INACTIVE",
                "baseStatus": "SUSPENDED",
                "contractIdentifier": "HR-2022-0001",
                "alias": "Hausratversicherung",
                "startDate": "2022-01-01",
                "plannedEndDate": null,
                "endDate": null,
                "contractTerminationInfo": null,
                "prices": [
                  {
                    "id": 70001,
                    "startDate": "2024-01-01",
                    "endDate": null,
                    "paymentFree": false,
                    "frequency": "MONTHLY",
                    "paymentAmount": 12.04,
                    "paymentAmountMonthly": 12.04,
                    "paymentAmountAnnually": 144.48,
                    "priceGross": 12.04,
                    "priceNet": 10.12,
                    "tax": 19,
                    "taxAmount": 1.92,
                    "commissionAmount": 2.5,
                    "commissionAmountMonthly": 2.5,
                    "commissionAmountAnnually": 30,
                    "feeAmount": 0.5,
                    "riskPremiumAmount": 7.12,
                    "currency": "EUR"
                  }
                ]
              }
            },
            {
              "id": 50002,
              "startDate": "2023-06-01",
              "endDate": null,
              "frequency": "MONTHLY",
              "firstPaymentDate": "2023-06-01",
              "nextPaymentDate": "2025-01-01",
              "contract": {
                "id": 60002,
                "entityStatus": "INACTIVE",
                "baseStatus": "SUSPENDED",
                "contractIdentifier": "GL-2023-0007",
                "alias": "Glasbruchversicherung",
                "startDate": "2023-06-01",
                "plannedEndDate": null,
                "endDate": null,
                "contractTerminationInfo": null,
                "prices": [
                  {
                    "id": 70002,
                    "startDate": "2024-01-01",
                    "endDate": null,
                    "paymentFree": false,
                    "frequency": "MONTHLY",
                    "paymentAmount": 6.25,
                    "paymentAmountMonthly": 6.25,
                    "paymentAmountAnnually": 75,
                    "priceGross": 6.25,
                    "priceNet": 5.25,
                    "tax": 19,
                    "taxAmount": 1,
                    "commissionAmount": 1.2,
                    "commissionAmountMonthly": 1.2,
                    "commissionAmountAnnually": 14.4,
                    "feeAmount": 0.3,
                    "riskPremiumAmount": 3.75,
                    "currency": "EUR"
                  }
                ]
              }
            }
          ]
        }
      }],
      "form": null,
      "info": null,
      "metrics": null,
      "messages": []
    }
  },
  "executionRuntime": 10
}